import {AvoirFournisseurLigneDto} from "./avoir-fournisseur-ligne-dto";
import {PrixDto} from "../../../prix-dto";
import {FactureFournisseurDto} from "../factures/facture-fournisseur-dto";
import {MailHistoDTO} from "../../../mail-histo-dto";

export class AvoirFournisseurDto {
  id: number;
  statut: string;
  code: String;
  reference: String;
  facture: FactureFournisseurDto;
  montant: PrixDto;
  montantValide: PrixDto;
  commentaire: String;
  lignes: AvoirFournisseurLigneDto[] = [];
  emailHisto: MailHistoDTO[];
  bonLivraisonNumeroList: string[] = [];
  dateReception: Date;

  public static getAllProperties = (): String => {
    return `
      id,
      statut,
      code,
      reference,
      facture {
        ${FactureFournisseurDto.getAllProperties()}
      },
      montant {
        value,
        uniteMonetaire
      },
      montantValide {
        value,
        uniteMonetaire
      },
      commentaire,
      bonLivraisonNumeroList,
      dateReception,
      lignes {
        ${AvoirFournisseurLigneDto.getAllProperties()}
      },
      emailHisto {
        sentDate,
        readDate,
        statut,
        token,
        emitterNom,
        emitterPrenom,
        emitterEmail,
        receiver,
        extraInfos,
        erreur
      }
    `
  }
}
